// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-settings .settingsContainer {
  display: flex;
  flex-direction: row;
}
app-settings .settingsContainer .radio-row {
  display: inline-flex;
  flex-direction: column !important;
}
app-settings .settingsContainer .radio-row .radio-faux-label {
  font-weight: 600;
  padding-left: 15px;
  padding-bottom: 10px;
}
app-settings .settingsContainer .radio-row .radio-faux-label-text {
  font-weight: 600;
}
app-settings .settingsContainer .defaultSettingContainer {
  flex: 0 1 180px;
}
app-settings .settingsContainer .offsenseNameContainer {
  flex: 0 1 40%;
  font-weight: 600;
}
app-settings .settingsContainer .spacerContainer {
  flex: 0 1 740px;
  font-weight: 600;
}
app-settings .settingsContainer .buttonContainer-spaced {
  flex: auto;
}
app-settings .settingsContainer .buttonContainer-spaced .propertyOverrideSaveButton {
  background-color: green;
  margin-right: 10px !important;
}
app-settings .settingsContainer .howManyAllowedContainer {
  flex: 0 1 280px;
}
app-settings .settingsContainer .howManyAllowedContainer label {
  margin-bottom: 0 !important;
}
app-settings .settingsContainer .howLongContainer {
  flex: 0 1 190px;
}
app-settings .settingsContainer .howLongContainer .howLongInput {
  width: 50px;
}
app-settings .settingsContainer .howLongContainer .yearsLabel {
  font-weight: 600;
  padding-left: 10px;
}
app-settings .settingsContainer .decisionContainer {
  flex: 0 1 270px;
}
app-settings .settingsContainer .decisionContainer .radio-row {
  padding-right: 15px;
  text-align: center;
  padding-bottom: 15px;
}
app-settings .settingsContainer .buttonContainer {
  flex: 0 1 70px;
}
app-settings .settingsContainer .buttonContainer .propertyOverrideLabel {
  font-size: 11px;
}
app-settings .settingsContainer .buttonContainer .saveButton {
  background-color: green;
}
app-settings .masterCrimeContainer {
  display: flex;
  flex-direction: column;
}
app-settings .masterCrimeContainer .settingsReadout {
  padding: 5px;
  background-color: #f7ebef;
  margin-right: 50px;
}
app-settings .masterCrimeContainer .settingsReadout .description {
  font-weight: bold;
}
app-settings .masterCrimeContainer .settingsReadout .highlightedBlock {
  padding-left: 5px;
  padding-right: 5px;
  color: blue;
  text-decoration: underline;
  text-transform: capitalize;
}
app-settings .propertyOverrideContainer {
  background-color: aquamarine;
  border: none;
  margin-top: 12px;
  padding-top: 16px;
  padding-bottom: 0px;
}
app-settings .propertyOverrideContainer .buttonContainer {
  flex: 0 1 70px;
}
app-settings .propertyOverrideContainer .buttonContainer .propertyOverrideSaveButton {
  background-color: green;
}
app-settings .propertyOverrideContainer .buttonContainer .propertyOverrideDeleteButton {
  background-color: red;
}
app-settings .propertyOverrideContainerResults {
  background-color: aquamarine;
  padding-bottom: 7px;
}
app-settings .propertyOverrideContainerResults .settingsReadout {
  padding: 5px;
  background-color: #f7ebef;
}
app-settings .propertyOverrideContainerResults .settingsReadout .description {
  font-weight: bold;
}
app-settings .propertyOverrideContainerResults .settingsReadout .highlightedBlock {
  padding-left: 5px;
  padding-right: 5px;
  color: blue;
  text-decoration: underline;
  text-transform: capitalize;
}
app-settings .mat-mdc-radio-button label {
  display: flex;
  flex-direction: column !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/decision-grid/Components/settings/settings.component.less"],"names":[],"mappings":"AAAA;EAII,aAAA;EACA,mBAAA;AAFJ;AAHA;EAQM,oBAAA;EACA,iCAAA;AAFN;AAPA;EAYQ,gBAAA;EACA,kBAAA;EACA,oBAAA;AAFR;AAZA;EAiBQ,gBAAA;AAFR;AAfA;EAuBM,eAAA;AALN;AAlBA;EA4BM,aAAA;EACA,gBAAA;AAPN;AAtBA;EAiCM,eAAA;EACA,gBAAA;AARN;AA1BA;EAsCM,UAAA;AATN;AA7BA;EAyCQ,uBAAA;EACA,6BAAA;AATR;AAjCA;EA+CM,eAAA;AAXN;AApCA;EAoDQ,2BAAA;AAbR;AAvCA;EAyDM,eAAA;AAfN;AA1CA;EA4DQ,WAAA;AAfR;AA7CA;EAgEQ,gBAAA;EACA,kBAAA;AAhBR;AAjDA;EAsEM,eAAA;AAlBN;AApDA;EAyEQ,mBAAA;EACA,kBAAA;EACA,oBAAA;AAlBR;AAzDA;EAgFM,cAAA;AApBN;AA5DA;EAmFQ,eAAA;AApBR;AA/DA;EAuFQ,uBAAA;AArBR;AAlEA;EA8FI,aAAA;EACA,sBAAA;AAzBJ;AAtEA;EAkGM,YAAA;EACA,yBAAA;EACA,kBAAA;AAzBN;AA3EA;EAuGQ,iBAAA;AAzBR;AA4BM;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,0BAAA;AA1BR;AArFA;EAqHI,4BAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AA7BJ;AA5FA;EA8HM,cAAA;AA/BN;AA/FA;EAiIQ,uBAAA;AA/BR;AAlGA;EAqIQ,qBAAA;AAhCR;AAqCE;EAEE,4BAAA;EACA,mBAAA;AApCJ;AAsCI;EACE,YAAA;EACA,yBAAA;AApCN;AAkCI;EAKI,iBAAA;AApCR;AAuCM;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,0BAAA;AArCR;AAvHA;EAuKM,aAAA;EACA,iCAAA;AA7CN","sourcesContent":["app-settings {\n\n  .settingsContainer {\n\n    display: flex;\n    flex-direction: row;\n\n    .radio-row {\n      display: inline-flex;\n      flex-direction: column !important;\n      \n      .radio-faux-label {\n        font-weight: 600;\n        padding-left: 15px;\n        padding-bottom: 10px;\n      }\n      .radio-faux-label-text {\n        font-weight: 600;\n      }\n    }\n\n    \n    .defaultSettingContainer {\n      flex: 0 1 180px;\n    }\n\n    .offsenseNameContainer {\n      // flex: 1;\n      flex: 0 1 40%;\n      font-weight: 600;\n    }\n\n    .spacerContainer {\n      flex: 0 1 740px;\n      font-weight: 600;\n    }\n\n    .buttonContainer-spaced {\n      flex: auto;\n      \n      .propertyOverrideSaveButton {\n        background-color: green;\n        margin-right: 10px !important;\n      }\n    }\n\n    .howManyAllowedContainer {\n      flex: 0 1 280px;\n\n      \n\n      label {\n        margin-bottom: 0 !important;\n      }\n    }\n\n    .howLongContainer {\n      flex: 0 1 190px;\n\n      .howLongInput {\n        width: 50px;\n      }\n\n      .yearsLabel {\n        font-weight: 600;\n        padding-left: 10px;\n      }\n    }\n\n    .decisionContainer {\n      flex: 0 1 270px;\n\n      .radio-row {\n        padding-right: 15px; \n        text-align: center;\n        padding-bottom: 15px;\n      }\n    }\n\n    .buttonContainer {\n      flex: 0 1 70px;\n\n      .propertyOverrideLabel {\n        font-size: 11px;\n      }\n\n      .saveButton {\n        background-color: green;\n      }\n    }\n  }\n\n  .masterCrimeContainer {\n\n    display: flex;\n    flex-direction: column;\n\n    .settingsReadout {\n      padding: 5px;\n      background-color: #f7ebef;\n      margin-right: 50px;\n\n      .description {\n        font-weight: bold;\n      }\n\n      & .highlightedBlock {\n        padding-left: 5px;\n        padding-right: 5px;\n        color: blue;\n        text-decoration: underline;\n        text-transform: capitalize;\n      }\n    }\n  }\n\n  .propertyOverrideContainer {\n    background-color: aquamarine;\n    border: none;\n    margin-top: 12px;\n    padding-top: 16px;\n    padding-bottom: 0px;\n    // margin-left: 20px;\n    // padding-left: 20px;\n\n    .buttonContainer {\n      flex: 0 1 70px;\n\n      .propertyOverrideSaveButton {\n        background-color: green;\n      }\n\n      .propertyOverrideDeleteButton {\n        background-color: red;\n      }\n    }\n  }\n\n  & .propertyOverrideContainerResults {\n\n    background-color: aquamarine;\n    padding-bottom: 7px;\n\n    & .settingsReadout {\n      padding: 5px;\n      background-color: #f7ebef;\n\n      .description {\n        font-weight: bold;\n      }\n\n      & .highlightedBlock {\n        padding-left: 5px;\n        padding-right: 5px;\n        color: blue;\n        text-decoration: underline;\n        text-transform: capitalize;\n      }\n    }\n  }\n\n\n  // Put the radio button labels underneath\n  .mat-mdc-radio-button {\n    \n    label {\n      //padding: 10px;\n      display: flex;\n      flex-direction: column !important;\n      \n      \n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
